<template>
  <div class="box-page">

    <i-modal ref="modalConfirmation" class="modal-small">
      <template v-slot:header>
        <div></div>
      </template>
      <template v-slot:body>
        <AlertModal title="Konfirmasi" :message="confirmMessage" type="confirmation" @remove="$refs.modalConfirmation.modalHide()"
          @confirm="confirmProses" />
      </template>
      <template v-slot:footer>
        <div class="footer-modal">
          <div></div>
        </div>
      </template>
    </i-modal>
    <i-modal ref="modalAlert" class="modal-small">
      <template v-slot:header>
        <div></div>
      </template>
      <template v-slot:body>
        <AlertModal :message="alert" :title="success ? 'Berhasil' : 'Oops!'" :success="success" @remove="$refs.modalAlert.modalHide()" />
      </template>
      <template v-slot:footer>
        <div class="footer-modal">
          <div></div>
        </div>
      </template>
    </i-modal>

    <div class="col-12 pl-0 pr-0">
      <div class="col-12 pl-0 pr-0 d-flex flex-wrap">
        <div class="col-12 col-lg-12 pl-0 pr-0 pr-lg-3">
          <div class="col-12 pl-0 pr-0">
            <div class="col-12 p-4 mt-3 bg-white cus-box-shadow rounded-cus d-flex flex-wrap">
              <div class="col-12 col-md-6 pl-0 pb-1 mt-auto mb-4">
                <div class="col-12 pl-0 pr-0 font-size-sm-12 font-size-14">Penukaran Serial</div>
              </div>
              <div class="col-12 px-0">
                <div class="col-12 col-sm-4 px-0 d-flex">
                  <div class="pb-2 font-size-10">Tipe Penukaran</div>
                </div>
                <div class="col-12 col-sm-4 px-0 pb-3 d-flex">
                  <div class="col-12 px-0">
                    <v-select v-model="selectedConvertion" :options="listConvert" appendToBody class="font-size-10 rounded-cus focus-me"
                      label="label" @input="changeConvertion">
                      <template v-slot:no-options>
                        Saat ini tidak ada produk yang tersedia
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-sm-12 px-0" v-if="selectedConvertion">
                <div class="px-0 d-flex">
                  <div class="pb-2 font-size-10">Produk</div>
                </div>
                <div class="px-0 pb-3 d-flex">
                  <div class="col-12 px-0">
                    <v-select v-model="selectedProduct" :options="dataStock" appendToBody class="font-size-10 rounded-cus focus-me"
                      label="product_code_name" @input="getSerial">
                      <template v-slot:no-options>
                        Saat ini tidak ada produk yang tersedia
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="px-0 d-flex">
                  <div class="pb-2 font-size-10">Tipe Serial</div>
                </div>
                <div class="px-0 pb-3 d-flex">
                  <div class="col-12 col-md-4 px-0">
                    <v-select v-model="selectedTypeSerial" :options="listTypeSerial" appendToBody class="font-size-10 rounded-cus focus-me"
                      label="label" @input="changeSerialType">
                      <template v-slot:no-options>
                        Saat ini tidak ada produk yang tersedia
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="px-0 d-flex">
                  <div class="pb-2 font-size-10">Jumlah</div>
                </div>
                <div class="px-0 pb-3 d-flex">
                  <div class="col-12 px-0">
                    <input @keypress="onlyNumber" @keyup="cekMaxQty" @paste.prevent v-model="qtyConvertion" type="text"
                      class="font-size-10 rounded-cus focus-me form-control">
                  </div>
                </div>
              </div>
              <div class="col-md-6 px-xs-0  px-sm-0 px-md-4 px-0" v-if="selectedProduct">
                <div class="px-0 d-flex">
                  <div class="pb-2 font-size-10">Data Produk</div>
                </div>
                <div class="row">
                  <div class="col-6 pb-2 d-flex">Nama Produk</div>
                  <div class="col-6 pb-2 d-flex">{{ selectedProduct.product_name }}</div>
                  <div class="col-6 pb-2 d-flex">Stok Produk POS</div>
                  <div class="col-6 pb-2 d-flex">{{ selectedProduct.stock_pos }}</div>
                  <div class="col-6 pb-2 d-flex">Stok Produk Store</div>
                  <div class="col-6 pb-2 d-flex">{{ selectedProduct.stock_store }}</div>
                  <div class="col-6 pb-2 d-flex">Tipe Serial</div>
                  <div class="col-6 pb-2 d-flex">{{ selectedProduct.stock_serial_name }}</div>
                </div>
              </div>
              <div class="col-12 px-0 mt-4" v-if="selectedConvertion">
                <div class="row" v-if="listStockResults == 'error'">
                  <div class="col-12">Tidak ada Serial</div>
                </div>
                <div v-else-if="selectedTypeSerial.value == 'fisik'">
                  <div id="accordion">
                    <div class="card" v-for="serial in listDataSerial" :key="serial.type_id">
                      <div class="card-header d-flex justify-content-between" id="headingOne">
                        <div data-toggle="collapse" :data-target="'#collapse' + serial.type_id" aria-expanded="true"
                          :aria-controls="'#collapse' + serial.type_id">
                          {{ serial.serial_name }} ({{ serial.selectedSerial.length }} dari {{ serial.quantity * qtyConvertion }})
                        </div>
                        <div>
                          <label class="container-serial">Pilih Semua
                            <input v-model="serial.selectAllSerial" type="checkbox" @change="checkSerialSelected(serial)">
                            <span class="checkmark checkmark-red"></span>
                          </label>
                        </div>
                      </div>

                      <div :id="'collapse' + serial.type_id" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                        <div class="card-body row">
                          <div class="col-xs-12 col-sm-6 col-md-4 px-2 pb-3" v-for="(serialdata, index) in serial.serialList" :key="index">
                            <div class="px-3 py-1 cus-box-shadow rounded-pill">
                              <div class="d-flex justify-content-between">
                                <input type="text" :value="serialdata.stock_serial_value" readonly
                                  class="form-control form-control-sm no-border box-blue rounded-cus font-size-sm-10 font-size-12 mr-3">
                                <div class="pl-3 d-flex align-items-center">
                                  <input type="checkbox" class="form-check-input" :value="serialdata.stock_serial_value"
                                    v-model="serial.selectedSerial">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="row mb-3 px-md-4" v-if="stockSerialDigital.saldo >= 0 && stockSerialDigitalStore.saldo >= 0">
                    <div class="col-12 col-md-6 px-xs-0 px-sm-0 px-0" :class="selectedConvertion.from == 'pos' ? 'order-1' : 'order-2'">
                      <div class="row">
                        <div class="col-8 col-md-6 pb-2 d-flex">Saldo POS</div>
                        <div class="col-4 col-md-4 pb-2 d-flex justify-content-end mr-md-0">{{ stockSerialDigital.saldo }} <span
                            class="rounded-sm bg-blue color-white pr-2 pl-2 ml-2">BV</span></div>
                        <div class="col-8 col-md-6 pb-2 d-flex">Konversi BV {{ selectedConvertion.from == 'pos' ? 'Keluar' : 'Masuk' }}</div>
                        <div class="col-4 col-md-4 pb-2 d-flex justify-content-end mr-md-0">{{ digitalConvertion }} <span
                            class="rounded-sm bg-blue color-white pr-2 pl-2 ml-2">BV</span></div>
                        <div class="col-8 col-md-6 pb-2 d-flex">Total Saldo POS</div>
                        <div class="col-4 col-md-4 pb-2 d-flex justify-content-end mr-md-0">{{ posSaldo }} <span
                            class="rounded-sm bg-blue color-white pr-2 pl-2 ml-2">BV</span></div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 px-xs-0 px-sm-0 px-0 pt-3 pt-md-0"
                      :class="selectedConvertion.from == 'store' ? 'order-1' : 'order-2'">
                      <div class="row">
                        <div class="col-8 col-md-6 pb-2 d-flex">Saldo Store</div>
                        <div class="col-4 col-md-4 pb-2 d-flex justify-content-end mr-md-0">{{ stockSerialDigitalStore.saldo }} <span
                            class="rounded-sm bg-blue color-white pr-2 pl-2 ml-2">BV</span></div>
                        <div class="col-8 col-md-6 pb-2 d-flex"> Konversi BV {{ selectedConvertion.from == 'store' ? 'Keluar' : 'Masuk' }}</div>
                        <div class="col-4 col-md-4 pb-2 d-flex justify-content-end mr-md-0">{{ digitalConvertion }} <span
                            class="rounded-sm bg-blue color-white pr-2 pl-2 ml-2">BV</span></div>
                        <div class="col-8 col-md-6 pb-2 d-flex">Saldo Store</div>
                        <div class="col-4 col-md-4 pb-2 d-flex justify-content-end mr-md-0">{{ storeSaldo }} <span
                            class="rounded-sm bg-blue color-white pr-2 pl-2 ml-2">BV</span></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12 text-right mt-2">
                  <button class="col-3 btn bg-blue color-white no-box-focus" @click="proses">
                    <div class="d-flex justify-content-center">
                      <div class="mr-2 font-size-11 font-weight-bold">Proses</div>
                      <i class="fas fa-arrow-right mt-1"></i>
                    </div>
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex';
import IModal from '@/components/IModal.vue';
import AlertModal from '@/components/elements/alert/AlertModal.vue';
import serialApi from "@/api/serial";

export default {
  components: {
    IModal,
    AlertModal
  },
  data() {
    return {
      confirmMessage: '',
      alert: '',
      success: 'alert',
      listConvert: [
        {
          label: "POS ke Store",
          from: "pos",
          to: "store",
        },
        {
          label: "Store ke POS",
          from: "store",
          to: "pos",
        }
      ],
      listTypeSerial: [
        {
          label: "Digital",
          value: "digital",
        },
        {
          label: "Fisik",
          value: "fisik",
        }
      ],
      selectedConvertion: '',
      qtyConvertion: 0,
      selectedProduct: '',
      selectedTypeSerial: '',
      selectedSerial: [],
      selectAllSerial: false,
      listDataSerial: [],
    }
  },
  computed: {
    ...mapState('inventoryList', ['dataStock', 'listStockResults', 'dataWarehouse']),
    ...mapState('inventoryListDigital', ['stockSerialDigital', 'stockSerialDigitalStore']),

    serialSelected() {
      return this.listDataSerial.map(el => {
        return {
          serial: el.selectedSerial,
          type_id: el.type_id,
          serial_name: el.serial_name,
          quantity: el.quantity
        }
      })
    },
    digitalConvertion() {
      let convertion = 0;
      convertion = this.qtyConvertion * this.selectedProduct.product_bv
      if(isNaN(convertion)){
        return convertion = 0
      }
      return convertion
    },
    posSaldo() {
      let saldo = 0;
      if (this.selectedConvertion.from == 'pos') {
        saldo = this.stockSerialDigital.saldo - this.digitalConvertion
      } else {
        saldo = this.stockSerialDigital.saldo + this.digitalConvertion
      }
      if(isNaN(saldo)){
        return saldo = 0
      }
      return saldo
    },
    storeSaldo() {
      let saldo = 0;
      if (this.selectedConvertion.from == 'store') {
        saldo = this.stockSerialDigitalStore.saldo - this.digitalConvertion
      } else {
        saldo = this.stockSerialDigitalStore.saldo + this.digitalConvertion
      }
      if(isNaN(saldo)){
        return saldo = 0
      }
      return saldo
    },
  },
  methods: {
    ...mapActions('inventoryList', ['getStock', 'getListSerial', 'convertSerialStock']),
    ...mapActions('inventoryListDigital', ['getDataStockSummarySerialDigital', 'getDataStockSummarySerialDigitalStore']),
    ...mapMutations('inventoryList', ['listSerial']),


    checkSerialSelected(data) {
      if (data.selectAllSerial === true) {
        data.selectedSerial = data.serialList.map(el => el.stock_serial_value)
      } else {
        data.selectedSerial = []
      }
    },
    getSerial() {
      this.listDataSerial = []
      if (this.selectedProduct) {
        let productIsSerial = JSON.parse(this.selectedProduct.product_is_serial)
        if (typeof (productIsSerial) == "object") {
          productIsSerial.forEach(async (el) => {
            let listDataSerial = await this.apiListSerial(el.type_id)
            if (listDataSerial) {
              el.serialList = listDataSerial
              el.selectedSerial = []
              el.selectAllSerial = false
              this.listDataSerial.push(el)
            }
          })
        }
      }
    },
    async apiListSerial(type_id) {
      let params = [
        {
          value: type_id,
          comparison: '=',
          type: 'string',
          field: 'stock_serial_type',
        }, {
          value: '0',
          comparison: '=',
          type: 'string',
          field: 'stock_serial_status',
        }, {
          value: '0',
          comparison: '=',
          type: 'string',
          field: 'stock_serial_stockist_network_id',
        }, {
          value: this.selectedConvertion.from,
          comparison: '=',
          type: 'string',
          field: 'stock_serial_used_for',
        }];

      return await new Promise(resolve => {
        this.$store.commit('PROGRESS_START', null, { root: true });
        serialApi.dataSerial(this.queryString({
          params: params,
          limit: 10000
        })).then(({ data: { data } }) => {
          this.$store.commit('PROGRESS_FINISH', null, { root: true });
          resolve(data.results)
        }).catch(() => {
          this.$store.commit('PROGRESS_FAIL', null, { root: true })
        });
      })
    },
    changeConvertion() {
      this.qtyConvertion = 0
      if (this.selectedProduct) {
        this.getSerial()
        this.cekMaxQty()
      }
    },
    changeSerialType() {
      if (this.selectedTypeSerial.value == 'digital') {
        this.getDataStockSummarySerialDigital()
        this.getDataStockSummarySerialDigitalStore()
      }
    },
    cekMaxQty() {
      if (this.selectedProduct) {
        let maxQty = 0
        if (this.selectedConvertion.from == 'pos') {
          maxQty = this.selectedProduct.stock_pos
        } else if (this.selectedConvertion.from == 'store') {
          maxQty = this.selectedProduct.stock_store
        }
        if (this.qtyConvertion > parseInt(maxQty)) {
            this.alert = 'Maximal jumlah penukaran adalah ' + maxQty
            this.success = false
            this.$refs.modalAlert.modalShow()
            this.qtyConvertion = maxQty
          }
      }
    },
    proses() {
      try {
        if (this.selectedTypeSerial.value == 'digital') {
          if (this.posSaldo < 0) {
            this.alert = 'Saldo BV POS tidak mencukupi'
            this.success = false
            this.$refs.modalAlert.modalShow()
            return
          } else if (this.storeSaldo < 0) {
            this.alert = 'Saldo BV Store tidak mencukupi'
            this.success = false
            this.$refs.modalAlert.modalShow()
            return
          }
        }
        if(this.selectedTypeSerial.value == 'fisik'){
          this.listDataSerial.forEach(serial => {
            let totalSerialNeeded = serial.quantity * this.qtyConvertion
            if (serial.selectedSerial == '' || serial.selectedSerial == 'error') {
              throw `Silahkan pilih ${serial.serial_name} terlebih dahulu`
            } else if (totalSerialNeeded != serial.selectedSerial.length) {
              throw `Jumlah ${serial.serial_name} tidak sesuai`
            }
          })
        }
        this.confirmMessage = 'Apakah anda yakin ingin memproses penukaran serial?'
        this.$refs.modalConfirmation.modalShow()
      }
      catch (err) {
        this.success = false
        this.alert = err
        this.$refs.modalAlert.modalShow()
      }
    },
    confirmProses() {
      let serialIsDigital = false
      let serialBv = 0

      if(this.selectedTypeSerial.value == 'digital') {
        this.selectedSerial = []
        serialIsDigital = true
        serialBv = this.digitalConvertion
      }

      let params = {
        convert_from: this.selectedConvertion.from,
        convert_to: this.selectedConvertion.to,
        product_id: this.selectedProduct.product_id,
        quantity: this.qtyConvertion,
        serial: JSON.stringify(this.serialSelected),
        serial_is_digital: serialIsDigital,
        serial_bv: serialBv,
      }
      this.convertSerialStock(params).then((message) => {
        this.$refs.modalConfirmation.modalHide()
        this.alert = message
        this.success = true
        this.clearData()
        this.$refs.modalAlert.modalShow()
      }).catch(({ data }) => {
        if (data.message == "error_validation") {
          this.alert = Object.values(data.data).join(', ')
        } else if (data.message == "error_multiple_alert") {
          this.alert = data.data.error.join(', ')
        } else {
          this.alert = data.message
        }

        this.success = false
        this.$refs.modalConfirmation.modalHide()
        this.$refs.modalAlert.modalShow()
      })

      this.selectedTypeSerial = ''
      this.getDataStockSummarySerialDigital()
      this.getDataStockSummarySerialDigitalStore()
    },
    getStockProduct() {
      this.getStock(this.queryString({
        limit: 100,
        params: [
          {
            value: '0',
            comparison: 'is_not',
            type: 'null',
            field: 'product_is_serial',
          }
        ]
      }));
    },
    clearData() {
      this.getStockProduct()
      this.listSerial({ data: [] })
      this.selectedConvertion = ''
      this.qtyConvertion = 0
      this.selectedProduct = ''
      this.selectAllSerial = false
    }
  },
  created() {
    this.getStockProduct()
    this.$store.dispatch('setPageTitle', 'Penukaran Serial');
  },
  mounted() { },
  watch: {

  }
};

</script>
